import React from 'react';
import { Grid } from '@material-ui/core';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import SelectWithValidation from '../../ValidationFormElements/SelectWithValidation';
import { getRoadCareTransportReleasedYears } from '../../../helpers/roadCare/roadCareCalcHelper';
import { bindTransportUsageTypesSelectOption } from '../../../helpers/selectHelpers';

const RoadCareCalculatorInputs = ({
  formProps,
  releaseYear,
  handleChangeReleaseYear,
  transportUseType,
  disabledUseTypeInput,
}) => {
  const { errors, clearError } = formProps;
  const { transportUsageTypes } = useSelector((state) => state.vehiclesReducer);
  const { i18n } = useTranslation();

  return (
    <Grid container spacing={4}>
      <Grid item xs={12} sm={6}>
        <SelectWithValidation
          required
          name="releaseYear"
          label="transportation.releaseYear"
          value={releaseYear}
          formProps={{
            errors,
            clearError,
          }}
          getMenuLabel={(option) => option.label}
          options={getRoadCareTransportReleasedYears()}
          onChange={(data) => handleChangeReleaseYear(data)}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <SelectWithValidation
          required
          disabled={disabledUseTypeInput}
          name="transportUseType"
          label="transportation.vehicleType"
          value={transportUseType}
          formProps={{
            errors,
            clearError,
          }}
          getMenuLabel={(option) => (option.label ? option.label[i18n.language] : '')}
          options={bindTransportUsageTypesSelectOption(transportUsageTypes)}
          onChange={() => {}}
        />
      </Grid>
    </Grid>
  );
};

RoadCareCalculatorInputs.propTypes = {
  formProps: PropTypes.shape({
    register: PropTypes.func,
    setValue: PropTypes.func,
    getValues: PropTypes.func,
    errors: PropTypes.shape({}),
    triggerValidation: PropTypes.func,
    clearError: PropTypes.func,
  }).isRequired,
  disabledUseTypeInput: PropTypes.bool.isRequired,
  releaseYear: PropTypes.shape({}),
  handleChangeReleaseYear: PropTypes.func.isRequired,
  transportUseType: PropTypes.shape({
    id: PropTypes.number,
    label: PropTypes.shape({
      en: PropTypes.string,
      hy: PropTypes.string,
      ru: PropTypes.string,
    }),
  }),
};

RoadCareCalculatorInputs.defaultProps = {
  releaseYear: {},
  transportUseType: {},
};

export default RoadCareCalculatorInputs;
